import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { ActionType } from '@store/action-type.constant.t'
import { loginPersonByWx } from '@api/user.api'
import { setLocalUser } from '@service/user.service'
import './index.css'
import { useHistory } from 'react-router-dom'
export default function Loading() {
  const dispatch = useDispatch()
  const history = useHistory();
  const fullUrl = window.location.href;

  useEffect(() => {
    async function loginByWx(code: string, appid: string) {
      const res = await loginPersonByWx(code, appid);
      if (res.personId) {
        // set redux
        dispatch({ type: ActionType.SET_USER, payload: res })
        // set localstorage
        setLocalUser(res);
        if(!res.mobile){
          history.push('/bind');
        }
      }
    }

    document.title = '一起装';
    // if localuser
    if (window.localStorage.user) {
      const localUser = JSON.parse(window.localStorage.user);
      window.accessToken=localUser.accessToken;
      dispatch({ type: ActionType.SET_USER, payload: localUser });
      if(!localUser.mobile){
        history.push('/bind');
      }
    }
    // else if has code
    else if (fullUrl.includes('code=') && fullUrl.includes('appid=')) {
      const codeReg = /code=([\d\w]*)[&#]/
      const appidReg = /appid=([\d\w]*)[&#]/
      const code = codeReg.exec(fullUrl)?.[1];
      const appid = appidReg.exec(fullUrl)?.[1];
      if (code && appid) {
        loginByWx(code, appid);
      }
    }
    // else gotologin
    else {
      // const loginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.REACT_APP_APP_ID}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=${process.env.REACT_APP_PLATFORM_APP_ID}#wechat_redirect`; /* eslint-disable-line */
      // window.location.href = loginUrl;
    }
  })

  return (
    <div className="wrapper">
      <div className="text-wrapper">
        <div className="text">页面跳转中...</div>
      </div>
    </div>
  )
}